module.exports = __webpack_public_path__ + "6dba1294e25fe8b9103f90639380ba12.svg";